<!-- Ported from the Polaris kit: src/product/components/ScenarioCard.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs;
     strings moved to i18n by hand. Change the design in the kit first. -->
<script setup>
// A scenario: when it applies, what the agent does and which tools it may use. The instruction is long, so it shows a few lines
// and opens in place.
import { useI18n } from 'vue-i18n';
import { computed, ref } from 'vue';
import { Edit16, TrashCan16 } from '@carbon/icons-vue';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '../ui/card';
import RowMenu from './RowMenu.vue';

const props = defineProps({
  title: { type: String, required: true },
  description: { type: String, default: '' }, // when it applies
  instruction: { type: String, required: true },
  tools: { type: Array, default: () => [] },
  // Hand change (Fase 4): cenário desligado (ex.: semeado pelo template) mostra o chip "Não ativado".
  inactive: { type: Boolean, default: false },
});

const emit = defineEmits(['action']);

const { t } = useI18n();

const open = ref(false);
const long = computed(() => props.instruction.length > 180);
const items = [
  { label: t('POLARIS.CARDS.EDIT_SCENARIO'), value: 'edit', icon: Edit16 },
  {
    label: t('POLARIS.CARDS.DELETE_SCENARIO'),
    value: 'delete',
    icon: TrashCan16,
    destructive: true,
  },
];
</script>

<template>
  <Card class="gap-3 py-4" data-scenario-card>
    <CardHeader class="px-4">
      <CardTitle class="flex items-center gap-2">
        {{ title }}
        <Badge v-if="inactive" variant="outline" class="font-normal">
          {{ t('POLARIS.CARDS.SCENARIO_INACTIVE') }}
        </Badge>
      </CardTitle>
      <CardDescription>{{ description }}</CardDescription>
      <CardAction>
        <RowMenu
          :label="`Actions for ${title}`"
          :items="items"
          @action="value => emit('action', { action: value })"
        />
      </CardAction>
    </CardHeader>
    <CardContent class="grid justify-items-start gap-1 px-4">
      <p
        class="type-polaris-body text-polaris-muted-foreground"
        :class="[!open && long ? 'line-clamp-3' : '']"
      >
        {{ instruction }}
      </p>
      <Button
        v-if="long"
        type="button"
        variant="link"
        size="sm"
        class="h-auto min-h-6 p-0"
        :aria-expanded="open"
        @click="open = !open"
      >
        {{ open ? t('POLARIS.CARDS.SHOW_LESS') : t('POLARIS.CARDS.SHOW_MORE') }}
      </Button>
    </CardContent>
    <CardFooter v-if="tools.length" class="flex-wrap gap-1.5 px-4">
      <Badge v-for="tool in tools" :key="tool" variant="outline">
        {{ tool }}
      </Badge>
    </CardFooter>
  </Card>
</template>
